
  export const reseiptTypeObj = 
    {
      '04':"实物签收",
      '10':"电子签收",
      'X0':"电子签收",
    }


// WEBPACK FOOTER //
// ./src/pages/billVerification/createBills/artificialCreate/config.js